import { DrawingShape } from '~/core/models';

export const getNextEdgeIndex = (shape: DrawingShape, edgeIndex: number) =>
  edgeIndex === shape.drawingEdges.length - 1 ? 0 : edgeIndex + 1;
